export default "/assets/images/tech_page_02_sm.6a5088ca311ea14e.mp4";